goog.provide("shadow.js.shim.module$$mui$material$Pagination$default");
shadow.js.shim.module$$mui$material$Pagination$default = shadow.js.shim.module$$mui$material$Pagination.default;
